import { useState, useRef, useEffect } from "react";
import {
  Search, Send, Phone, Video, MoreVertical, Paperclip,
  Smile, Check, CheckCheck, ArrowLeft, Hash, Star,
  Archive, Trash2, Image, FileText, X, Plus,
  BookOpen, GraduationCap, Bell, Reply, Users, Mic
} from "lucide-react";

// ─── Data ─────────────────────────────────────────────────────────────────────

const conversations = [
  {
    id: 1, type: "direct", name: "Sarah Johnson", avatar: "SJ",
    avatarColor: "#7C3AED", role: "Student · Mobile Dev",
    online: true, starred: true, unread: 3,
    lastMessage: "I'm having trouble with the assignment deadline...", lastTime: "2m ago",
    messages: [
      { id: 1, from: "SJ", text: "Good morning Dr. Adeyemi! I wanted to ask about the React Native assignment.", time: "9:10 AM", status: "read" },
      { id: 2, from: "me", text: "Good morning Sarah! Of course, what's your question?", time: "9:12 AM", status: "read" },
      { id: 3, from: "SJ", text: "I'm struggling with the navigation stack. The back button doesn't work correctly with nested navigators.", time: "9:14 AM", status: "read" },
      { id: 4, from: "me", text: "Ah, that's a common issue! Use the useNavigation() hook instead of prop drilling — it gives you the nearest navigator automatically.", time: "9:17 AM", status: "read" },
      { id: 5, from: "SJ", text: "Oh that makes sense! Let me try that.", time: "9:18 AM", status: "read" },
      { id: 6, from: "SJ", text: "It worked! Thank you so much 🎉", time: "9:25 AM", status: "read" },
      { id: 7, from: "me", text: "Great! Don't forget the assignment is due this Friday. Let me know if you run into anything else.", time: "9:26 AM", status: "read" },
      { id: 8, from: "SJ", text: "I'm having trouble with the assignment deadline, can we extend it by a day?", time: "10:32 AM", status: "delivered" },
    ]
  },
  {
    id: 2, type: "direct", name: "John Smith", avatar: "JS",
    avatarColor: "#0284C7", role: "Student · Web Dev",
    online: true, starred: false, unread: 0,
    lastMessage: "Thanks for the feedback on my project!", lastTime: "1h ago",
    messages: [
      { id: 1, from: "JS", text: "Dr. Adeyemi, I submitted my React project for review.", time: "8:00 AM", status: "read" },
      { id: 2, from: "me", text: "I saw it John. Good work overall! Your component structure is clean. I left a few notes on state management.", time: "8:45 AM", status: "read" },
      { id: 3, from: "JS", text: "Thanks for the feedback on my project!", time: "9:00 AM", status: "read" },
    ]
  },
  {
    id: 3, type: "group", name: "Web Dev Cohort 2024", avatar: "WD",
    avatarColor: "#059669", role: "24 members",
    online: false, starred: true, unread: 12,
    lastMessage: "Mike: When is the next live session?", lastTime: "30m ago",
    messages: [
      { id: 1, from: "Mike Chen", text: "Hey everyone, has anyone finished the CSS Grid assignment?", time: "8:00 AM", status: "read" },
      { id: 2, from: "Emily Davis", text: "Still working on it! The responsive part is tricky.", time: "8:05 AM", status: "read" },
      { id: 3, from: "me", text: "Good morning all! Remember to use minmax() for truly responsive grids. Check Module 4 for the example.", time: "8:30 AM", status: "read" },
      { id: 4, from: "Mike Chen", text: "That example helped so much, thank you!", time: "8:35 AM", status: "read" },
      { id: 5, from: "Carlos Rivera", text: "Same! My layout finally works on mobile 🙌", time: "8:40 AM", status: "read" },
      { id: 6, from: "Aisha Patel", text: "Dr. Adeyemi, will there be a recording of the live session?", time: "9:00 AM", status: "read" },
      { id: 7, from: "me", text: "Yes, all sessions are recorded and uploaded within 2 hours.", time: "9:05 AM", status: "read" },
      { id: 8, from: "Mike Chen", text: "When is the next live session?", time: "10:00 AM", status: "read" },
    ]
  },
  {
    id: 4, type: "direct", name: "Mike Chen", avatar: "MC",
    avatarColor: "#D97706", role: "Student · Data Science",
    online: false, starred: false, unread: 0,
    lastMessage: "I'll send the updated notebook tomorrow.", lastTime: "Yesterday",
    messages: [
      { id: 1, from: "MC", text: "Hi Dr. Adeyemi, my Jupyter notebook has some issues with the pandas version.", time: "Yesterday 3:00 PM", status: "read" },
      { id: 2, from: "me", text: "Try downgrading to pandas 1.5.3. Some methods changed in 2.0.", time: "Yesterday 3:30 PM", status: "read" },
      { id: 3, from: "MC", text: "I'll send the updated notebook tomorrow.", time: "Yesterday 4:00 PM", status: "read" },
    ]
  },
  {
    id: 5, type: "group", name: "Backend Engineering", avatar: "BE",
    avatarColor: "#DC2626", role: "18 members",
    online: false, starred: false, unread: 0,
    lastMessage: "You: Check the Docker documentation I shared.", lastTime: "2 days ago",
    messages: [
      { id: 1, from: "Tom Wilson", text: "I can't get Docker to run on Windows.", time: "2 days ago", status: "read" },
      { id: 2, from: "me", text: "Check the Docker documentation I shared.", time: "2 days ago", status: "read" },
    ]
  },
  {
    id: 6, type: "direct", name: "Emily Davis", avatar: "ED",
    avatarColor: "#DB2777", role: "Student · Web Dev",
    online: false, starred: false, unread: 1,
    lastMessage: "Could we schedule a one-on-one session?", lastTime: "3h ago",
    messages: [
      { id: 1, from: "ED", text: "Hi Dr. Adeyemi, I'm falling behind on the course material.", time: "7:00 AM", status: "read" },
      { id: 2, from: "ED", text: "Could we schedule a one-on-one session?", time: "7:05 AM", status: "delivered" },
    ]
  },
  {
    id: 7, type: "direct", name: "Carlos Rivera", avatar: "CR",
    avatarColor: "#0891B2", role: "Student · Backend Eng",
    online: true, starred: false, unread: 0,
    lastMessage: "Got it, I'll push the changes tonight.", lastTime: "5h ago",
    messages: [
      { id: 1, from: "CR", text: "Should I use PostgreSQL or MongoDB for the project?", time: "6:00 AM", status: "read" },
      { id: 2, from: "me", text: "Given your use case with relational data, go with PostgreSQL. You'll benefit from joins and ACID compliance.", time: "6:30 AM", status: "read" },
      { id: 3, from: "CR", text: "Got it, I'll push the changes tonight.", time: "6:35 AM", status: "read" },
    ]
  },
];

const emojiList = ["👍", "❤️", "😂", "😮", "😢", "🙏", "🔥", "✅"];

// ─── Helpers ──────────────────────────────────────────────────────────────────

function AvatarBubble({ initials, color, size = 40, online = false }) {
  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      <div style={{
        width: size, height: size, borderRadius: 14,
        background: color, display: "flex", alignItems: "center",
        justifyContent: "center", color: "#fff",
        fontWeight: 700, fontSize: size * 0.32, letterSpacing: 0.5
      }}>
        {initials}
      </div>
      {online && (
        <div style={{
          position: "absolute", bottom: -2, right: -2,
          width: 11, height: 11, borderRadius: "50%",
          background: "#22C55E", border: "2px solid #fff"
        }} />
      )}
    </div>
  );
}

function MessageBubble({ msg, isMe, showSender }) {
  const [hover, setHover] = useState(false);
  const [reaction, setReaction] = useState(null);
  const [showEmoji, setShowEmoji] = useState(false);

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setShowEmoji(false); }}
      style={{
        display: "flex", flexDirection: isMe ? "row-reverse" : "row",
        gap: 8, alignItems: "flex-end", marginBottom: 4
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: isMe ? "flex-end" : "flex-start", maxWidth: "68%" }}>
        {showSender && !isMe && (
          <span style={{ fontSize: 11, fontWeight: 600, color: "#94A3B8", marginBottom: 3, marginLeft: 4 }}>
            {msg.from}
          </span>
        )}
        <div style={{ position: "relative" }}>
          <div style={{
            padding: "10px 14px",
            borderRadius: isMe ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
            background: isMe ? "linear-gradient(135deg, #6366F1, #4F46E5)" : "#F1F5F9",
            color: isMe ? "#fff" : "#1E293B",
            fontSize: 14, lineHeight: 1.5,
            boxShadow: isMe ? "0 2px 12px rgba(99,102,241,0.25)" : "0 1px 4px rgba(0,0,0,0.06)",
            border: isMe ? "none" : "1px solid #E2E8F0"
          }}>
            {msg.text}
          </div>
          {reaction && (
            <div style={{
              position: "absolute", bottom: -10,
              [isMe ? "left" : "right"]: 8,
              background: "#fff", border: "1px solid #E2E8F0",
              borderRadius: 20, padding: "1px 6px", fontSize: 13,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)", zIndex: 2
            }}>
              {reaction}
            </div>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 3, marginTop: 4, flexDirection: isMe ? "row-reverse" : "row", paddingInline: 4 }}>
          <span style={{ fontSize: 10, color: "#94A3B8" }}>{msg.time}</span>
          {isMe && (
            msg.status === "read"
              ? <CheckCheck size={12} color="#6366F1" />
              : <Check size={12} color="#94A3B8" />
          )}
        </div>
      </div>

      {/* Hover actions */}
      <div style={{
        display: "flex", gap: 2, alignItems: "center", alignSelf: "center",
        opacity: hover ? 1 : 0, transition: "opacity 0.15s", position: "relative"
      }}>
        <div style={{ position: "relative" }}>
          <button onClick={() => setShowEmoji(!showEmoji)} style={actionBtnStyle}>
            <Smile size={14} color="#94A3B8" />
          </button>
          {showEmoji && (
            <div style={{
              position: "absolute", bottom: 32, [isMe ? "right" : "left"]: 0,
              background: "#fff", border: "1px solid #E2E8F0", borderRadius: 16,
              padding: 8, display: "flex", gap: 4, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", zIndex: 20
            }}>
              {emojiList.map(e => (
                <button key={e} onClick={() => { setReaction(e); setShowEmoji(false); }}
                  style={{ fontSize: 16, background: "none", border: "none", cursor: "pointer", padding: 2, borderRadius: 6, transition: "transform 0.1s" }}
                  onMouseEnter={el => el.currentTarget.style.transform = "scale(1.3)"}
                  onMouseLeave={el => el.currentTarget.style.transform = "scale(1)"}
                >
                  {e}
                </button>
              ))}
            </div>
          )}
        </div>
        <button style={actionBtnStyle}><Reply size={14} color="#94A3B8" /></button>
        <button style={actionBtnStyle}><MoreVertical size={14} color="#94A3B8" /></button>
      </div>
    </div>
  );
}

const actionBtnStyle = {
  background: "#F8FAFC", border: "1px solid #E2E8F0",
  borderRadius: 8, padding: "4px 6px", cursor: "pointer",
  display: "flex", alignItems: "center", justifyContent: "center"
};

// ─── Main Component ───────────────────────────────────────────────────────────

export default function ChatPage() {
  const [convos, setConvos] = useState(conversations);
  const [activeId, setActiveId] = useState(1);
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [typing, setTyping] = useState(false);
  const [attachMenu, setAttachMenu] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const active = convos.find(c => c.id === activeId);
  const totalUnread = convos.reduce((s, c) => s + c.unread, 0);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [activeId, convos, typing]);

  const selectConvo = (id) => {
    setConvos(prev => prev.map(c => c.id === id ? { ...c, unread: 0 } : c));
    setActiveId(id);
  };

  const sendMessage = () => {
    if (!input.trim()) return;
    const text = input.trim();
    const newMsg = {
      id: Date.now(), from: "me", text,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      status: "delivered"
    };
    setConvos(prev => prev.map(c =>
      c.id === activeId
        ? { ...c, messages: [...c.messages, newMsg], lastMessage: `You: ${text}`, lastTime: "now" }
        : c
    ));
    setInput("");
    inputRef.current?.focus();
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      const replies = ["Thanks for letting me know!", "Got it, I'll look into that.", "Perfect, see you then!", "That makes sense, thank you!", "I'll get back to you shortly."];
      const reply = {
        id: Date.now() + 1, from: active.name,
        text: replies[Math.floor(Math.random() * replies.length)],
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        status: "read"
      };
      setConvos(prev => prev.map(c =>
        c.id === activeId
          ? { ...c, messages: [...c.messages, reply], lastMessage: reply.text, lastTime: "now" }
          : c
      ));
    }, 1800);
  };

  const filtered = convos.filter(c => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase());
    const matchFilter =
      filter === "all" ||
      (filter === "unread" && c.unread > 0) ||
      (filter === "starred" && c.starred) ||
      (filter === "groups" && c.type === "group");
    return matchSearch && matchFilter;
  });

  return (
    <div style={{
      display: "flex", width: "100%", height: "calc(100vh - 6rem)",
      borderRadius: 20, overflow: "hidden",
      boxShadow: "0 8px 40px rgba(0,0,0,0.10)", background: "#fff",
      border: "1px solid #E2E8F0"
    }}>

      {/* ══════════════ LEFT PANEL — 40% ══════════════ */}
      <div style={{
        width: "40%", minWidth: 280, display: "flex", flexDirection: "column",
        borderRight: "1px solid #E2E8F0", background: "#FAFBFF", flexShrink: 0
      }}>
        {/* Header */}
        <div style={{ padding: "20px 20px 0", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
            <div>
              <h2 style={{ fontSize: 22, fontWeight: 800, color: "#0F172A", margin: 0 }}>Messages</h2>
              {totalUnread > 0 && (
                <p style={{ fontSize: 12, color: "#94A3B8", margin: "2px 0 0" }}>{totalUnread} unread</p>
              )}
            </div>
            <div style={{ display: "flex", gap: 4 }}>
              <button style={iconBtnStyle}><Plus size={18} color="#64748B" /></button>
              <button style={iconBtnStyle}><MoreVertical size={18} color="#64748B" /></button>
            </div>
          </div>

          {/* Search */}
          <div style={{ position: "relative", margin: "16px 0 12px" }}>
            <Search size={15} color="#94A3B8" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }} />
            <input
              style={{
                width: "100%", padding: "10px 12px 10px 36px", borderRadius: 12,
                border: "1px solid #E2E8F0", background: "#F1F5F9", fontSize: 13,
                color: "#334155", outline: "none", boxSizing: "border-box"
              }}
              placeholder="Search conversations..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {/* Filters */}
          <div style={{ display: "flex", gap: 6, paddingBottom: 16, borderBottom: "1px solid #E2E8F0" }}>
            {[
              { id: "all", label: "All" },
              { id: "unread", label: "Unread" },
              { id: "starred", label: "Starred" },
              { id: "groups", label: "Groups" },
            ].map(f => (
              <button key={f.id} onClick={() => setFilter(f.id)} style={{
                padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600,
                cursor: "pointer", border: "none", transition: "all 0.2s",
                background: filter === f.id ? "#6366F1" : "#EEF2FF",
                color: filter === f.id ? "#fff" : "#6366F1"
              }}>
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {/* Conversation List */}
        <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
          {filtered.map(convo => {
            const isActive = convo.id === activeId;
            return (
              <div key={convo.id} onClick={() => selectConvo(convo.id)} style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 20px", cursor: "pointer", transition: "all 0.15s",
                background: isActive ? "#EEF2FF" : "transparent",
                borderLeft: isActive ? "3px solid #6366F1" : "3px solid transparent",
              }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "#F8FAFF"; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
              >
                <AvatarBubble initials={convo.avatar} color={convo.avatarColor} size={46} online={convo.online} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 2 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 5, minWidth: 0 }}>
                      {convo.type === "group" && <Hash size={12} color="#94A3B8" style={{ flexShrink: 0 }} />}
                      <span style={{
                        fontSize: 14, fontWeight: convo.unread ? 700 : 600,
                        color: "#0F172A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
                      }}>
                        {convo.name}
                      </span>
                      {convo.starred && <Star size={11} color="#F59E0B" fill="#F59E0B" style={{ flexShrink: 0 }} />}
                    </div>
                    <span style={{ fontSize: 10, color: "#94A3B8", whiteSpace: "nowrap", marginLeft: 6 }}>{convo.lastTime}</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <p style={{
                      fontSize: 12, color: convo.unread ? "#334155" : "#94A3B8",
                      fontWeight: convo.unread ? 500 : 400,
                      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", margin: 0, flex: 1
                    }}>
                      {convo.lastMessage}
                    </p>
                    {convo.unread > 0 && (
                      <div style={{
                        minWidth: 20, height: 20, borderRadius: 10, background: "#6366F1",
                        color: "#fff", fontSize: 10, fontWeight: 700,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "0 5px", marginLeft: 6, flexShrink: 0
                      }}>
                        {convo.unread}
                      </div>
                    )}
                  </div>
                  <p style={{ fontSize: 11, color: "#CBD5E1", margin: "2px 0 0" }}>{convo.role}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ══════════════ RIGHT PANEL — 60% ══════════════ */}
      {active ? (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#fff", minWidth: 0 }}>

          {/* Chat Header */}
          <div style={{
            display: "flex", alignItems: "center", gap: 12, padding: "14px 20px",
            borderBottom: "1px solid #E2E8F0", background: "#fff", flexShrink: 0,
            boxShadow: "0 1px 8px rgba(0,0,0,0.04)"
          }}>
            <AvatarBubble initials={active.avatar} color={active.avatarColor} size={42} online={active.online} />
            <div style={{ flex: 1, minWidth: 0, cursor: "pointer" }} onClick={() => setShowInfo(!showInfo)}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {active.type === "group" && <Hash size={14} color="#94A3B8" />}
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#0F172A", margin: 0 }}>{active.name}</h3>
              </div>
              <p style={{ fontSize: 12, margin: "2px 0 0", color: typing ? "#6366F1" : active.online ? "#22C55E" : "#94A3B8", fontWeight: typing || active.online ? 600 : 400 }}>
                {typing ? "typing…" : active.online ? "● Online" : active.role}
              </p>
            </div>
            <div style={{ display: "flex", gap: 2 }}>
              {[Phone, Video, MoreVertical].map((Icon, i) => (
                <button key={i} style={iconBtnStyle}><Icon size={17} color="#64748B" /></button>
              ))}
            </div>
          </div>

          {/* Messages */}
          <div style={{
            flex: 1, overflowY: "auto", padding: "20px 24px",
            background: "linear-gradient(180deg, #F8FAFF 0%, #FAFAFA 100%)",
            display: "flex", flexDirection: "column", gap: 8
          }}>
            {/* Date pill */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
              <div style={{ flex: 1, height: 1, background: "#E2E8F0" }} />
              <span style={{
                fontSize: 11, color: "#94A3B8", fontWeight: 600,
                background: "#EEF2FF", padding: "4px 12px", borderRadius: 20
              }}>Today</span>
              <div style={{ flex: 1, height: 1, background: "#E2E8F0" }} />
            </div>

            {active.messages.map((msg, idx) => {
              const isMe = msg.from === "me";
              const prev = active.messages[idx - 1];
              const showSender = active.type === "group" && !isMe && (!prev || prev.from !== msg.from);
              return <MessageBubble key={msg.id} msg={msg} isMe={isMe} showSender={showSender} />;
            })}

            {/* Typing indicator */}
            {typing && (
              <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
                <div style={{
                  padding: "10px 16px", background: "#F1F5F9", borderRadius: "18px 18px 18px 4px",
                  border: "1px solid #E2E8F0", display: "flex", gap: 4, alignItems: "center"
                }}>
                  {[0, 0.2, 0.4].map((d, i) => (
                    <div key={i} style={{
                      width: 7, height: 7, borderRadius: "50%", background: "#94A3B8",
                      animation: "bounce 1s infinite", animationDelay: `${d}s`
                    }} />
                  ))}
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div style={{ padding: "12px 20px 16px", borderTop: "1px solid #E2E8F0", background: "#fff", flexShrink: 0 }}>
            {attachMenu && (
              <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                {[
                  { icon: Image, label: "Photo", bg: "#EDE9FE", color: "#7C3AED" },
                  { icon: FileText, label: "File", bg: "#E0F2FE", color: "#0284C7" },
                  { icon: BookOpen, label: "Course", bg: "#DCFCE7", color: "#059669" },
                  { icon: GraduationCap, label: "Assignment", bg: "#FEF3C7", color: "#D97706" },
                ].map(item => (
                  <button key={item.label} onClick={() => setAttachMenu(false)} style={{
                    display: "flex", flexDirection: "column", alignItems: "center", gap: 4,
                    padding: "8px 12px", borderRadius: 12, border: "none", background: item.bg,
                    cursor: "pointer", transition: "transform 0.15s"
                  }}
                    onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                    onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                  >
                    <item.icon size={18} color={item.color} />
                    <span style={{ fontSize: 10, color: item.color, fontWeight: 600 }}>{item.label}</span>
                  </button>
                ))}
              </div>
            )}

            <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
              <button onClick={() => setAttachMenu(!attachMenu)} style={{
                ...iconBtnStyle,
                background: attachMenu ? "#EEF2FF" : "#F1F5F9",
                color: attachMenu ? "#6366F1" : "#64748B"
              }}>
                {attachMenu ? <X size={18} color="#6366F1" /> : <Paperclip size={18} color="#64748B" />}
              </button>

              <div style={{ flex: 1, position: "relative" }}>
                <textarea
                  ref={inputRef} rows={1}
                  style={{
                    width: "100%", padding: "11px 16px", borderRadius: 16,
                    border: "1.5px solid #E2E8F0", background: "#F8FAFC",
                    fontSize: 14, color: "#334155", outline: "none", resize: "none",
                    boxSizing: "border-box", maxHeight: 100, lineHeight: 1.5,
                    transition: "border-color 0.2s", fontFamily: "inherit"
                  }}
                  placeholder={`Message ${active.name}…`}
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  onFocus={e => e.target.style.borderColor = "#6366F1"}
                  onBlur={e => e.target.style.borderColor = "#E2E8F0"}
                  onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
                />
              </div>

              <button style={iconBtnStyle}><Smile size={18} color="#64748B" /></button>

              <button onClick={sendMessage} disabled={!input.trim()} style={{
                width: 42, height: 42, borderRadius: 14, border: "none", cursor: input.trim() ? "pointer" : "not-allowed",
                background: input.trim() ? "linear-gradient(135deg, #6366F1, #4F46E5)" : "#E2E8F0",
                display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: input.trim() ? "0 4px 12px rgba(99,102,241,0.35)" : "none",
                transition: "all 0.2s", flexShrink: 0
              }}>
                <Send size={17} color={input.trim() ? "#fff" : "#94A3B8"} />
              </button>
            </div>
            <p style={{ fontSize: 10, color: "#CBD5E1", textAlign: "center", marginTop: 8 }}>
              Enter to send · Shift+Enter for new line
            </p>
          </div>
        </div>
      ) : (
        // Empty state
        <div style={{
          flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", background: "#FAFBFF", gap: 12
        }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: "#EEF2FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Users size={30} color="#6366F1" />
          </div>
          <p style={{ fontSize: 17, fontWeight: 700, color: "#0F172A", margin: 0 }}>Select a conversation</p>
          <p style={{ fontSize: 13, color: "#94A3B8", margin: 0 }}>Choose from the list to start messaging</p>
        </div>
      )}


    </div>
  );
}

const iconBtnStyle = {
  width: 36, height: 36, borderRadius: 10, border: "1px solid #E2E8F0",
  background: "#F8FAFC", display: "flex", alignItems: "center",
  justifyContent: "center", cursor: "pointer", flexShrink: 0, transition: "all 0.15s"
};